import { useMutation } from "@shared/lib/hooks";

import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { ToastService } from "@shared/lib/services";
import { ReportService } from "../services/Report.servie";

export function useExportReport(handleSuccess?: () => void) {
  const {
    mutate: exportReport,
    isLoading: isExporting,
    isSuccess: isExported,
  } = useMutation({
    mutationFn: async (reportId: string) => {
      return await ReportService.exportReport(reportId).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _) => {
      ToastService.success("Report exported successfully");
      c.invalidateQueries({
        queryKey: [...DOWNLOADS_LIST_QUERY_KEY],
        exact: false,
      });
      handleSuccess?.();
    },
  });
  return {
    exportReport,
    isExporting,
    isExported,
  };
}
